module.exports = __webpack_public_path__ + "files/d87e2b940040180747e1c202a8d67b75.png";